import { useSelector, useDispatch } from "react-redux";
import "./modal.scss";
import { closeModal } from "store/modal.slice";
import { IoClose } from "react-icons/io5";
import { MdCheckCircle, MdError } from "react-icons/md";
import { useEffect, useRef } from "react";
import useEscapeKey from "hook/useEscapeKey";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import React from "react";
import { useFocusTrap } from "hook/useFocusTrap";

export interface ModalType {
    id: string;
    title: string;
    text: string[];
    status: string;
    autoClose?: boolean;
    isModalOpen?: boolean;
    blocking?: boolean;
    position?: string;
    buttons?: JSX.Element[];
}

const Modal = () => {
    const modal: ModalType = useSelector((state: any) => state.modal);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const modalContainerRef = useRef<HTMLDivElement>(null);

    useEscapeKey(() => dispatch(closeModal()));
    useFocusTrap(modalContainerRef, modal.isModalOpen ?? false);

    useEffect(() => {
        if (!modal.isModalOpen || !modalContainerRef.current) return;

        modalContainerRef.current.focus();

    }, [modal.isModalOpen]);

    return (
        <>
            {modal.isModalOpen && (
                <>
                    {modal.blocking && <div className="modalWrapper"></div>}
                    <div
                        ref={modalContainerRef}
                        id={modal.id}
                        role="dialog"
                        tabIndex={-1}
                        aria-modal="true"
                        aria-label={modal.title}
                        className={`modal ${modal.position} ${modal?.status}`} >

                        <div className={"modal__data"}>
                            <div className="modal__data__title">
                                {modal?.status === "success" ? (
                                    <MdCheckCircle className="success" />
                                ) : modal?.status === "error" ? (
                                    <MdError className="error" />
                                ) : (
                                    ""
                                )}
                                <p>{modal?.title}</p>
                            </div>
                            {modal.text && modal.text.map((txt: string, i: number) => {
                                return (
                                    <div key={`modalText_${i}`}>
                                        <p className="text-md text-zinc-900 pb mt-2">{txt}</p>
                                    </div>)
                            })}
                            {modal.buttons && modal.buttons.length > 0 && (
                                <div className="modal__data__buttons">
                                    {modal.buttons.map((button: JSX.Element, index: number) =>
                                        React.cloneElement(button, {
                                            key: index,
                                        })
                                    )}
                                </div>
                            )}
                        </div>

                        <Button
                            variant="light"
                            onClick={() => dispatch(closeModal())}
                            className="modal__button_close"
                            aria-label={t("close_modal")}
                        >
                            <IoClose />
                        </Button>
                    </div>
                </>
            )}
        </>
    );
};
export default Modal;
